export default __webpack_public_path__ + "static/media/pdf_file.e5b383dc.svg";